document.addEventListener('DOMContentLoaded', function () {
  var checkbox = document.querySelector('[data-fp-cart-protection]');
  if (!checkbox) return;

  checkbox.addEventListener('change', function () {
    var variantId = checkbox.getAttribute('data-protection-variant-id');
    var quantity = checkbox.checked ? 1 : 0;
    checkbox.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      })
      .catch(function () {
        checkbox.disabled = false;
        checkbox.checked = !checkbox.checked;
      });
  });
});
